<template>
  <div class="sobre">
    <section class="sobre-hero">
      <div class="container" data-aos="fade-up">
        <h1>Sobre Nós</h1>
        <p>Conheça a história e os valores da LLyon Engenharia</p>
      </div>
    </section>

    <section class="sobre-content">
      <div class="container">
        <div class="sobre-grid">
          <div class="sobre-text" data-aos="fade-right">
            <h2>Nossa História</h2>
            <p>Laerte, engenheiro mecânico residente em São Paulo, com vasta experiência comprovada na área de
              engenharia e
              segurança, fundou a LLyon Engenharia com o objetivo de oferecer soluções técnicas de alta qualidade e
              segurança para seus clientes.</p>

            <h2>Nossa Missão</h2>
            <p>Proporcionar serviços de engenharia mecânica com excelência, garantindo a segurança e qualidade em cada
              projeto,
              sempre seguindo as normas técnicas vigentes e as melhores práticas do mercado.</p>

            <h2>Nossos Valores</h2>
            <ul class="valores-list">
              <li><i class="fas fa-check"></i> Compromisso com a segurança</li>
              <li><i class="fas fa-check"></i> Excelência técnica</li>
              <li><i class="fas fa-check"></i> Responsabilidade profissional</li>
              <li><i class="fas fa-check"></i> Atendimento personalizado</li>
              <li><i class="fas fa-check"></i> Inovação constante</li>
            </ul>
          </div>

          <div class="sobre-image" data-aos="fade-left">
            <div class="placeholder">
              <i class="fas fa-building"></i>
              <p>Imagem da Empresa</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="diferenciais">
      <div class="container">
        <h2 data-aos="fade-up">Nossos Diferenciais</h2>
        <div class="diferenciais-grid">
          <div class="diferencial-card" data-aos="fade-up" data-aos-delay="100">
            <i class="fas fa-user-tie"></i>
            <h3>Profissionais Qualificados</h3>
            <p>Equipe altamente capacitada e em constante atualização</p>
          </div>
          <div class="diferencial-card" data-aos="fade-up" data-aos-delay="200">
            <i class="fas fa-clock"></i>
            <h3>Pontualidade</h3>
            <p>Compromisso com prazos e cronogramas estabelecidos</p>
          </div>
          <div class="diferencial-card" data-aos="fade-up" data-aos-delay="300">
            <i class="fas fa-hand-holding-usd"></i>
            <h3>Preço Justo</h3>
            <p>Orçamentos transparentes e competitivos</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Sobre'
}
</script>

<style lang="scss" scoped>
.sobre {
  .sobre-hero {
    background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), #2c3e50;
    background-size: cover;
    background-position: center;
    height: 40vh;
    display: flex;
    align-items: center;
    text-align: center;
    color: white;

    .container {
      max-width: 800px;
      margin: 0 auto;
      padding: 0 1rem;

      h1 {
        font-size: 3rem;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.2rem;
      }
    }
  }

  .sobre-content {
    padding: 5rem 0;

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 1rem;
    }

    .sobre-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4rem;
      align-items: center;
    }

    .sobre-text {
      h2 {
        color: var(--primary-color);
        margin-bottom: 1.5rem;
        font-size: 2rem;
      }

      p {
        margin-bottom: 2rem;
        line-height: 1.8;
      }

      .valores-list {
        list-style: none;
        padding: 0;

        li {
          margin-bottom: 1rem;
          display: flex;
          align-items: center;

          i {
            color: var(--secondary-color);
            margin-right: 1rem;
          }
        }
      }
    }

    .sobre-image {
      .placeholder {
        width: 100%;
        height: 400px;
        background-color: #2c3e50;
        border-radius: 10px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: white;

        i {
          font-size: 4rem;
          margin-bottom: 1rem;
        }

        p {
          font-size: 1.2rem;
        }
      }
    }

    .sobre-imagem {
      background-color: #2c3e50;
      border-radius: 10px;
      overflow: hidden;
      height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 1.5rem;
    }
  }

  .diferenciais {
    background-color: var(--light-bg);
    padding: 5rem 0;

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 1rem;
    }

    h2 {
      text-align: center;
      color: var(--primary-color);
      margin-bottom: 3rem;
    }

    .diferenciais-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 2rem;
    }

    .diferencial-card {
      text-align: center;
      padding: 2rem;
      background: white;
      border-radius: 10px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      transition: transform 0.3s ease;

      &:hover {
        transform: translateY(-5px);
      }

      i {
        font-size: 2.5rem;
        color: var(--secondary-color);
        margin-bottom: 1rem;
      }

      h3 {
        margin-bottom: 1rem;
        color: var(--primary-color);
      }
    }
  }
}

@media (max-width: 768px) {
  .sobre {
    .sobre-hero {
      height: 30vh;
      padding-top: 4rem;

      .container {
        h1 {
          font-size: 2rem;
        }

        p {
          font-size: 1rem;
        }
      }
    }

    .sobre-content {
      padding: 3rem 0;

      .sobre-grid {
        grid-template-columns: 1fr;
        gap: 2rem;
      }

      .sobre-text {
        h2 {
          font-size: 1.5rem;
          margin-bottom: 1rem;
        }

        p {
          font-size: 1rem;
          margin-bottom: 1.5rem;
        }
      }

      .sobre-image {
        .placeholder {
          height: 250px;

          i {
            font-size: 3rem;
          }

          p {
            font-size: 1rem;
          }
        }
      }
    }

    .diferenciais {
      padding: 3rem 0;

      h2 {
        font-size: 1.5rem;
        margin-bottom: 2rem;
      }

      .diferenciais-grid {
        gap: 1.5rem;
      }

      .diferencial-card {
        padding: 1.5rem;

        i {
          font-size: 2rem;
        }

        h3 {
          font-size: 1.2rem;
        }

        p {
          font-size: 0.9rem;
        }
      }
    }
  }
}
</style>